export enum roles {
  Operator = 'operator',
  ProblemSolver = 'problem-solver',
  Supervisor = 'supervisor',
  TenantAdmin = 'tenant-admin',
  TenantOwner = 'tenant-owner',
  Admin = 'admin',
  SupportAdmin = 'support-admin',
}
